import { InputNumber, Slider } from 'antd';

import React from 'react';
import clsx from 'clsx';
import styles from './FTSlider.module.scss';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  min?: number;
  max?: number;
  value?: number;
  title?: string;
  onChange?: (value: number) => void;
  vertical?: boolean;
}

export default function FTSlider(props: IProps) {
  const { min, max, value, title, onChange, vertical } = props;
  return (
    <div className={clsx(styles.slider, vertical && styles.vertical)}>
      {title && <span className={styles.slider_title}>{title}</span>}
      <span className={styles.slider_value}>{value}</span>
      <Slider
        vertical={vertical}
        min={min}
        max={max}
        onChange={onChange}
        value={value}
      />
    </div>
  );
}
